import React from "react";

// reactstrap components
import {
  Spinner,
  Container,
  Row,
  Col
} from "reactstrap";
import { CardRegister, RegisterInfo } from 'components/Register/Register';

class Register extends React.Component {

  componentDidMount() {
    document.body.classList.toggle("register-page");
  }

  componentWillUnmount() {
    document.body.classList.toggle("register-page");
  }

  render() {
    return (
      <div className="register-page">
        <Container>
          <Row>
            
            <Col className="mr-auto card-register" md="6">
              {this.props.isLoading ? <Spinner color="warning"/>: <CardRegister acceptedTerms={this.props.acceptedTerms} onTermsOfUse={this.props.onTermsOfUse} doRegister={this.props.doRegister} errorMessage={this.props.errorMessage} email={this.props.email}  onChange={this.props.onChange}/>}
            </Col>
          </Row>
        </Container>
        <div
          className="full-page-background"
          style={{
            backgroundImage: `url(${require("assets/img/bg/fundo-registrar.jpg")})`
          }}
        />
      </div>
    );
  }
}

export default Register;

/* 
<Col className="ml-auto" lg="5" md="5">
  <RegisterInfo icon="nc-icon nc-tv-2" title="Lorem ipsum" description="Lorem ipsum dolor sit amet, consectetur adipiscing elit.Pellentesque vel sapien et elit laoreet elementum." />
  <RegisterInfo icon="nc-icon nc-send" title="Lorem ipsum" description="Lorem ipsum dolor sit amet, consectetur adipiscing elit.Pellentesque vel sapien et elit laoreet elementum." />
  <RegisterInfo icon="nc-icon nc-atom" title="Lorem ipsum" description="Lorem ipsum dolor sit amet, consectetur adipiscing elit.Pellentesque vel sapien et elit laoreet elementum." />
</Col>
*/